// src/request.js
import axios, { AxiosResponse } from "axios";
import { ElMessage, ElLoading } from "element-plus";
import { isDev } from "@/utils/env";
const baseURL = "/apis" + process.env.VUE_APP_API_PATH; //基础路径
const timeout = 5000; //超时时间
//设置请求头
const setHeaders = () => {
  let headers = {
    "Content-Type": "application/json",
  };
  return headers;
};

// 创建 axios 实例
const request = axios.create({
  baseURL,
  timeout,
  headers: setHeaders(),
});

// 响应日志
const logResponse = (response: AxiosResponse<any, any>) => {
  if (isDev()) {
    console.group("🎉 响应日志");
    console.log("响应数据:", response);
    console.groupEnd();
  }
};

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // 请求错误处理
    console.error("请求拦截器错误:", error);
    // console.error("请求失败，请稍后再试");
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 成功响应处理
    logResponse(response);

    if (response.status === 200 && response.data) {
      return response.data; // 返回实际数据
    } else {
      console.error(response.data?.message || "请求失败");
      return Promise.reject(response.data?.message || "请求失败");
    }
  },
  (error) => {
    // 响应错误处理
    const status = error.response?.status;

    if (status === 401) {
      console.error("未授权，请登录");
    } else if (status === 403) {
      console.error("禁止访问");
    } else if (status === 404) {
      console.error("请求资源未找到");
    } else if (status === 500) {
      console.error("服务器内部错误");
    } else {
      console.error(error.message || "请求失败");
    }

    return Promise.reject(error);
  }
);

// 封装请求方法
const http = {
  get: (url: string, params = {}, config = {}) => {
    return request.get(url, {
      params,
      ...config,
    });
  },
  post: (url: string, data = {}, config = {}) => {
    return request.post(url, data, {
      ...config,
    });
  },
  put: (url: string, data = {}, config = {}) => {
    return request.put(url, data, {
      ...config,
    });
  },
  delete: (url: string, config = {}) => {
    return request.delete(url, {
      ...config,
    });
  },
  upload: (url: string, data: any, config = {}) => {
    const loading = ElLoading.service({ background: "rgba(0, 0, 0, 0.7)" });
    return request
      .post(url, data, {
        ...config,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .finally(() => {
        loading.close();
      });
  },
  download: (url: string, params = {}, config = {}) => {
    return request
      .get(url, { params, responseType: "blob", ...config })
      .then((response) => {
        const content = response.headers["content-disposition"];
        const fileName = content
          .substring(content.indexOf("filename=") + 9)
          .replace(/"/g, "");
        const link = document.createElement("a");
        link.href = URL.createObjectURL(response.data);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      });
  },
};
export default http;
